// https://fontawesome.com/icons?d=gallery&c=interfaces&m=free
const map = {
    check: 'fas fa-check',
    minus: 'fas fa-minus',
    plus: 'fas fa-plus',
    gear: 'fas fa-cog',
    kebob: 'fas fa-ellipsis-v',
    trash: 'fas fa-trash-alt',
    edit: 'fas fa-pencil-alt',
    editSquare: 'fas fa-pen-square',
    books: 'fas fa-book-reader',
    chess: 'fas fa-chess-rook',
    error: 'fas fa-exclamation-circle',
    warning: 'fas fa-exclamation-triangle',
    search: 'fas fa-search',
    spinner: 'fas fa-sync-alt',
    close: 'far fa-times-circle',

    calendar: 'far fa-calendar-alt',
    calPlus: 'fas fa-calendar-plus',
    calMinus: 'fas fa-calendar-minus',

    caretDown: 'fas fa-caret-down',
    caretup: 'fas fa-caret-up',
    caretRight: 'fas fa-caret-right',
    caretLeft: 'fas fa-caret-left',

    angleLeft: 'fas fa-angle-left',
    anglesLeft: 'fas fa-angle-double-left',
    angleRight: 'fas fa-angle-right',
    anglesRight: 'fas fa-angle-double-right',
    angleUp: 'fas fa-angle-up',
    angleDown: 'fas fa-angle-down',

    sortUp: 'fas fa-sort-up',
    sortDown: 'fas fa-sort-down',

    copy: 'far fa-copy',
    folder: 'far fa-folder',
    file: 'far fa-file',
    'file-alt': 'far fa-file-alt',
    'file-archive': 'far fa-file-archive',
    'file-audio': 'far far fa-file-audio',
    'file-code': 'far far fa-file-code',
    'file-image': 'far far fa-file-image',
    'file-pdf': 'far far fa-file-pdf',
    'file-video': 'far far fa-file-video',
    'file-excel': 'far far fa-file-excel',
    'file-powerpoint': 'far far fa-file-powerpoint',
    'file-word': 'far far fa-file-word',
};

module.exports = map;
